export default function Footer() {
  return (
    <footer className="container mx-auto flex justify-center text-white">
      <span className="text-xs py-2 ">
        &copy; KOREA BOARDGAMES. ALL RIGHTS RESERVED.
      </span>
    </footer>
  );
}
